module.exports = __webpack_public_path__ + "static/media/electronic.e5baff87.jpg";